module.exports = __webpack_public_path__ + "static/lionjumperset-9439f703906bed54790519ed8770213e.jpeg";